import { Checkbox, Grid, Button } from '@mui/material';
import {ToggleButton,ToggleButtonGroup} from '@mui/material';
import useModuleMetadata from 'src/hooks/use-module-metadata.hook'
import StarRateIcon from '@mui/icons-material/StarRate';
import React, { useState,useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { getAccessConfigForScenario } from '../home/store/simulator-home-async-thunks';
import MODULE_TO_PAGE_MAP from '../home/types/simulation-module-to-page-map';
import { Scenario } from '../scenarios/types/scenario.model';
import { setSelectedSourceKey } from './store/cluster-summary-slice';
import './cluster-summary.scss';
import { fetchClusterSummaryData } from './store/cluster-summary-slice';
import ScenarioManagerSearchTopBar from '../scenario-manager/search-top-bar';

export default function ClusterSummaryTopBar(){

    return(
        <>
        <Grid 
         sx={{
            width:'70%',
            ml: 'auto', 
            mr: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        }}>
              <Grid item xs sx={{ textAlign: 'right' }} display='flex' alignItems='center'>
            {/* <Grid
            container
            spacing={1}
            alignItems='center'
            justifyContent='right'
            > */}
           <Grid>
            <div style={{ padding: '11px 7px 0 0' }}>
            <img
                src='/static/icons/finalized-scenario.svg'
                alt='finalized'
            />
            </div>
            </Grid>
            <Grid>
                <div className='finalized-scenario-label'>
                Finalized Scenarios
                </div>
            </Grid>
            <Grid item sx={{ ml: 1, flex: 1 }}>
                <ScenarioManagerSearchTopBar/>
            </Grid>
            {/* </Grid> */}
        </Grid>

        </Grid>

      

        </>
       
    );
}